import { useGetMenuResponse } from "../../hooks/useGetMenuResponse";
import type { MenuAction } from "../../services/types/menu";

export const useGetMenuActions = (menuId: string): MenuAction[] => {
  const menuResponse = useGetMenuResponse();

  return menuResponse?.menuActions.filter((i) => i.menuId === menuId) || [];
};
